import i18nImpl from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
import { TRANSLATIONS_EN } from "./en";
import { TRANSLATIONS_DE } from "./de";

i18nImpl
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LngDetector)
  .init({
    resources: {
      en: {
        translation: TRANSLATIONS_EN,
      },
      de: {
        translation: TRANSLATIONS_DE,
      },
    },
    fallbackLng: "de",
    debug: false,
    react: {
      transSupportBasicHtmlNodes: true,
    },
    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["querystring", "cookie", "navigator", "htmlTag", "path", "subdomain", "localStorage"],
    },
  });

export const i18n = i18nImpl;
